/*
Copyright (c) 2019-present NAVER Corp.
name: @egjs/vue-children-differ
license: MIT
author: NAVER Corp.
repository: https://github.com/naver/egjs-children-differ
version: 1.0.1
*/
import { diff } from '@egjs/children-differ';

/*
egjs-children-differ
Copyright (c) 2019-present NAVER Corp.
MIT license
*/
var vueChildrenDiffer = {
  componentUpdated: function (el, binding, vnode, oldVnode) {
    var oldChildren = oldVnode.children ? oldVnode.children.map(function (n) {
      return n && n.elm;
    }) : [];
    var newChildren = vnode.children ? vnode.children.map(function (n) {
      return n && n.elm;
    }) : [];
    var diffResult = diff(oldChildren, newChildren);
    binding.value(diffResult);
  }
};

export default vueChildrenDiffer;
//# sourceMappingURL=children-differ.esm.js.map
